import { Link } from 'react-router-dom';

export default function QuickAccessCards() {
  const cards = [
    {
      icon: 'ri-rocket-line',
      title: 'Onboarding',
      description: 'Get started with your step-by-step guide',
      link: '/backoffice/onboarding',
      color: 'bg-teal-100 text-teal-600',
    },
    {
      icon: 'ri-tools-line',
      title: 'Toolkits',
      description: 'Access marketing materials and resources',
      link: '/backoffice/tools',
      color: 'bg-blue-100 text-blue-600',
    },
    {
      icon: 'ri-book-open-line',
      title: 'Resources',
      description: 'Explore training and support materials',
      link: '/resources',
      color: 'bg-purple-100 text-purple-600',
    },
    {
      icon: 'ri-team-line',
      title: 'Agent Network',
      description: 'Connect with other agents',
      link: '/agents',
      color: 'bg-orange-100 text-orange-600',
    },
  ];

  // Defensive check: ensure `cards` is an array before rendering
  if (!Array.isArray(cards) || cards.length === 0) {
    return null; // or render a fallback UI
  }

  return (
    <section className="py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-2xl font-bold text-gray-900 mb-8">Quick Access</h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {cards.map((card, index) => (
            <Link
              key={index}
              to={card.link}
              className="bg-white rounded-lg p-6 shadow-sm border border-gray-200 hover:shadow-md transition-shadow group"
            >
              <div className={`w-12 h-12 ${card.color} rounded-lg flex items-center justify-center mb-4`}>
                <i className={`${card.icon} text-2xl`}></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2 group-hover:text-teal-600 transition-colors">
                {card.title}
              </h3>
              <p className="text-sm text-gray-600">{card.description}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
